<template>
  <address
    v-if="address"
    class="address"
    itemprop="address"
    itemtype="http://schema.org/PostalAddress"
    translate="no"
  >
    <span
      v-if="address.organization"
      class="address-description"
      itemprop="description"
      >{{ address.organization }}</span
    ><br />
    <span v-if="address.addressLine1" itemprop="streetAddress"
      >{{ address.addressLine1 }}<br />
    </span>
    <span v-if="address.postalCode" itemprop="postalCode">{{
      address.postalCode
    }}</span
    >&nbsp;
    <span v-if="address.locality" itemprop="addressRegion">{{
      address.locality
    }}</span
    ><br />
    <span v-if="address.countryCode" itemprop="addressCountry" class="hidden">{{
      address.countryCode
    }}</span>
  </address>
</template>

<script lang="ts" setup>
import type { AddressCardFragment } from '#graphql-operations'

defineProps<{
  address: AddressCardFragment['address']
}>()
</script>

<style lang="postcss">
.address {
  @apply not-italic;
}
.address-description {
  @apply font-bold;
}
</style>
